import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useGetSubscribersQuery, useUpdateSubscriberMutation } from '../../api/subscriberApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import PhoneField from '../../components/PhoneField/PhoneField';
import { phoneToDigits, digitsToPhone } from '../../utils/phone';
import buttons from '../../styles/shared/buttons.module.css';

export default function SubscriberEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const showToast = useToast();

  const { data: subscribers, isLoading } = useGetSubscribersQuery();
  const subscriber = subscribers?.find((sub) => sub.id === id);
  const [updateSubscriber, { isLoading: isSaving }] = useUpdateSubscriberMutation();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { email: '', phone: '' },
  });

  useEffect(() => {
    if (subscriber) reset({ email: subscriber.email, phone: phoneToDigits(subscriber.phone) });
  }, [subscriber, reset]);

  const onSave = async (data) => {
    try {
      await updateSubscriber({
        id,
        email: data.email.trim(),
        phone: digitsToPhone(data.phone),
      }).unwrap();
      showToast('success', 'Subscribers', 'Subscriber updated.');
      navigate('/manager/subscribers');
    } catch (err) {
      showToast('error', 'Subscribers', errMsg(err, 'Could not save subscriber.'));
    }
  };

  if (isLoading) return <p className="textMuted">Loading…</p>;
  if (!subscriber) return null;

  return (
    <EntityFormPage title="Edit subscriber" backTo="/manager/subscribers">
      <form onSubmit={handleSubmit(onSave)}>
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Email</label>
              <InputText id={field.name} type="email" className="w-full mb-3" {...field} />
            </div>
          )}
        />

        <PhoneField control={control} />

        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isSaving} />
      </form>
    </EntityFormPage>
  );
}
